import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import { MainModuleNgFactory } from "../../../compiled/src/main/client/main.module.ngfactory";

// if (environment.production) {
	// enableProdMode();
// }


platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.log(err));


// platformBrowser().bootstrapModuleFactory(MainModuleNgFactory).
//  	.catch(err => console.log(err));



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/main.ts